module.exports = __webpack_public_path__ + "2873b463254f2fd677bd4b539b20b88b.svg";